// extracted by mini-css-extract-plugin
export default {"back-button":"wdrMzo","backButton":"wdrMzo","title":"ZBrioL","title-text":"A4h1Fd","titleText":"A4h1Fd"};